import React from "react";
import { regiao } from "./data/cidades";
import { faixasDeDistancia } from "./data/locais";

const largura = 1000;
const altura = 1139;
const unidadesPorKm = 8.525;
const sede = regiao.find((cidade) => cidade.km === 0);
const aneis = [25, 50, 75];

const esquerda = ["Lauro Müller", "Pedras Grandes", "Treviso", "Siderópolis", "Nova Veneza", "Forquilhinha", "Imbituba"];
const abaixo = ["Tubarão"];
const abaixoADireita = ["São Ludgero"];

const rotulo = (cidade) => {
  if (esquerda.includes(cidade.nome)) return { x: cidade.x - 14, y: cidade.y + 8, textAnchor: "end" };
  if (abaixo.includes(cidade.nome)) return { x: cidade.x, y: cidade.y + 36, textAnchor: "middle" };
  if (abaixoADireita.includes(cidade.nome)) return { x: cidade.x + 10, y: cidade.y + 32, textAnchor: "start" };
  return { x: cidade.x + 14, y: cidade.y + 8, textAnchor: "start" };
};

const rotuloDoAnel = (km) => {
  const raio = km * unidadesPorKm;
  if (km === 25) return { x: sede.x, y: sede.y - raio + 8 };
  if (km === 50) return { x: sede.x + raio, y: sede.y + 8 };
  return { x: sede.x, y: sede.y + raio + 8 };
};

export const Mapa = ({ titulo }) => (
  <svg viewBox={`0 0 ${largura} ${altura}`} role="img" aria-labelledby="mapa-titulo" className="w-full h-auto" overflow="hidden">
    <title id="mapa-titulo">{titulo}</title>
    <image href="/mapa/sul-de-santa-catarina.svg" x="0" y="0" width={largura} height={altura} />
    {aneis.map((km) => (
      <circle key={km} cx={sede.x} cy={sede.y} r={km * unidadesPorKm} fill="none" stroke="#0475b6" strokeOpacity="0.45" strokeWidth="2" strokeDasharray="6 10" />
    ))}
    {aneis.map((km) => {
      const posicao = rotuloDoAnel(km);
      return (
        <text key={km} x={posicao.x} y={posicao.y} textAnchor="middle" className="fill-gray-500 font-sans hidden md:inline" fontSize="22" fontWeight="600" stroke="#fff" strokeWidth="6" strokeLinejoin="round" paintOrder="stroke">
          {`${km} km`}
        </text>
      );
    })}
    {regiao.filter((cidade) => cidade !== sede).map((cidade) => {
      const posicao = rotulo(cidade);
      return (
        <g key={cidade.nome}>
          <circle cx={cidade.x} cy={cidade.y} r="7" fill="#0475b6" stroke="#fff" strokeWidth="3" />
          <text x={posicao.x} y={posicao.y} textAnchor={posicao.textAnchor} className="fill-gray-800 font-sans hidden md:inline" fontSize="23" fontWeight="500" stroke="#fff" strokeWidth="6" strokeLinejoin="round" paintOrder="stroke">
            {cidade.nome}
          </text>
        </g>
      );
    })}
    <circle cx={sede.x} cy={sede.y} r="12" fill="#fff" stroke="#0475b6" strokeWidth="6" />
    <text x={sede.x} y={sede.y - 26} textAnchor="middle" className="fill-gray-900 font-display" fontSize="40" fontWeight="700" stroke="#fff" strokeWidth="8" strokeLinejoin="round" paintOrder="stroke">
      {sede.nome}
    </text>
  </svg>
);

export const Distancias = () => (
  <ul className="grid grid-cols-1 md:grid-cols-3 gap-10 xl:gap-16">
    {faixasDeDistancia.map((faixa) => (
      <li key={faixa.titulo} className="border-t-2 border-pattern pt-6">
        <h3 className="text-xl xl:text-2xl font-semibold mb-4">{faixa.titulo}</h3>
        <ul className="space-y-2 text-lg">
          {regiao
            .filter((cidade) => cidade.km >= faixa.minimo && cidade.km <= faixa.maximo)
            .sort((a, b) => a.km - b.km)
            .map((cidade) => (
              <li key={cidade.nome} className="flex justify-between gap-4 border-b border-gray-200 pb-2">
                <span className={cidade.km === 0 ? "font-semibold" : "text-gray-800"}>{cidade.nome}</span>
                <span className="text-gray-600 whitespace-nowrap">{cidade.km === 0 ? "sede" : `${cidade.km} km`}</span>
              </li>
            ))}
        </ul>
      </li>
    ))}
  </ul>
);
